import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { popupActions } from '../../../store/popupStore';
import { searchInstances } from '../../../store/relationsSearchStore';
import { relationsSearchActions } from '../../../store/relationsSearchStore';
import { windowActions } from '../../../store/windowStore';
import { withLocalize, Translate } from "react-localize-redux";
import { withRouter } from 'react-router';
import classnames from 'classnames'
import Message from '../../common/message';
import NavigationRow from "../../layoutItems/navigationRow";
import RelationsSearchInstance, { checkTypes } from "./relationsSearchInstance";
import RelationsSearchNavigator from "./relationsSearchNavigator";
import SearchTip from '../../common/searchTip';

class RelationsSearch extends React.Component {
    prefix = "/search/relations";

    state = {
        error: false
    }

    onEntityCheck(instance, checkedEntities) {
        this.props.setEntityId(instance, checkedEntities.length > 0 ? checkedEntities[0] : undefined);
        this.setError();
    }

    render() {
        return (
            <>
                <div className="content-root content-root-wide">
                    <RelationsSearchNavigator />
                    <SearchTip windowId='tips_rc_search' getSearchTipsModel={this.getSearchTipsModel} style={{ marginTop: '-2em' }} />
                    {this.state.error &&
                        <Message type="warning" message={this.props.translate('Search.Relations.Error.IdenticalEntities')} options={{ renderInnerHtml: true }} shadowed style={{ marginBottom: "1em" }} />}
                    <div className="columns is-multiline">
                        {
                            [searchInstances.first, searchInstances.second].map((instance, idx) =>
                                <div key={idx} className="column is-6">
                                    <div className="search-wrap">
                                        <div className={`search-content`} style={{ margin: '0em', padding: '0em' }}>
                                            <div className="search-container">
                                                <RelationsSearchInstance
                                                    instanceKey={instance}
                                                    ordinal={idx + 1}
                                                    checkType={checkTypes.single}
                                                    onEntityCheck={(v) => this.onEntityCheck(instance, v)}
                                                    scroller={this.props.scroller}
                                                    renderTypeTabs
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
                <NavigationRow justify='flex-end'>
                    <button
                        className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                        type="button"
                        disabled={!this.canContinue()}
                        onClick={() => this.onContinue()}>
                        <Translate id="Search.Relations.Continue.ToParameters" />
                    </button>
                </NavigationRow>
            </>
        )
    }

    getSearchTipsModel = () => {
        return { title: `${this.props.translate('Search.Relations')}`, bodyHtml: this.props.translate('SearchTips.Search.Relations.Body') };
    }

    setError = () => {
        this.setState({ error: this.state.error && this.canContinue() && this.props.rsa[searchInstances.first].entityId === this.props.rsa[searchInstances.second].entityId })
    }

    canContinue = () => {
        return this.props.rsa[searchInstances.first].entityId && this.props.rsa[searchInstances.second].entityId;
    }

    onContinue = () => {
        this.setState({ error: this.props.rsa[searchInstances.first].entityId === this.props.rsa[searchInstances.second].entityId }, () => {
            if (!this.state.error) {
                this.props.history.push({
                    pathname: `${this.prefix}/parameters/${this.props.rsa[searchInstances.first].entityId}/${this.props.rsa[searchInstances.second].entityId}`
                });
            }
        });
    }
}

export default withRouter(withLocalize(connect(state => { return { ...state.appContext, layout: state.layout, rsa: state.relationsSearch }; },
    dispatch => bindActionCreators({ ...windowActions, ...popupActions, ...relationsSearchActions }, dispatch))(RelationsSearch)));